<!-- ; -->

<app-card
	cardTitle
	cardClass="card-datatable"
	[options]="false">
	<form
		(ngSubmit)="search()"
		class="filterform">
		<div class="row">
			<div class="col-md-6">
				<div class="form-group d-flex flex-row">
					<input
						type="text"
						class="form-control d-inline"
						name="keyword"
						placeholder="Cerca..."
						[(ngModel)]="searchparams.genericSearchTerm">
					<button
						type="button"
						class="btn btn-link ml-2"
						(click)="toggleAdvanced()">
						<i class="feather icon-filter"></i>

					</button>
				</div>
			</div>
			<div class="col-md-4 mt-1">
				<div class="form-group">
					<div class="form-check form-check-inline">
						<input
							type="checkbox"
							class="form-check-input"
							name="active"
							[(ngModel)]="active">
						<label class="form-check-label">
							{{'labels.show-only-active' | translate}}
						</label>
					</div>
				</div>
			</div>

		</div>
		<div [ngbCollapse]="!showAdvancedSearch">
			<div class="row">
				<!-- name -->
				<div class="col-md-4">
					<div class="form-group">
						<label>{{'labels.name' | translate}}</label>
						<input
							type="text"
							class="form-control"
							name="fname"
							[(ngModel)]="searchparams.likeTmp['name']">
					</div>
				</div>
				<!-- company -->
				<div
					class="col-md-4"
					*ngIf="!companyid">
					<label>{{'labels.company' | translate}}</label>
					<app-entity-autocomplete
						entityName="company"
						entityField="name"
						entityFilterType="like"
						[entitySearch]="company.search"
						name="company"
						[(ngModel)]="company.selected"
						placeholder>
					</app-entity-autocomplete>

				</div>
				<!-- tender -->
				<div
					class="col-md-4"
					*ngIf="!tenderid">
					<label>{{'labels.tender' | translate}}</label>
					<app-entity-autocomplete
						entityName="tender"
						entityField="name"
						entityFilterType="like"
						[entitySearch]="tender.search"
						name="tender"
						[(ngModel)]="tender.selected"
						placeholder>
					</app-entity-autocomplete>

				</div>
				<!-- status -->
				<div class="col-md-4">
					<div class="form-group">
						<label>{{'labels.status' | translate}}</label>
						<select
							class="form-control custom-select"
							[(ngModel)]="searchparams.simpleTmp['status']"
							name="status">
							<option
								*ngFor="let st of stats"
								[value]="st">
								{{ 'labels.' + st | translate}}
							</option>
							<option value="all">{{'labels.alltypes' | translate }}</option>
						</select>
					</div>
				</div>
				<!-- budget -->
				<div class="col-md-4 mb-1">
					<label>{{'labels.budget' | translate}}</label>
					<div class="row">
						<div class="col-md-3">{{'labels.from' | translate}}:</div>
						<div class="col-md-3">
							<input
								type="number"
								class="form-control"
								name="from2"
								[(ngModel)]="budget.from">
						</div>

						<div class="col-md-3">{{'labels.to' | translate}}:</div>
						<div class="col-md-3">
							<input
								type="number"
								class="form-control"
								name="to2"
								[(ngModel)]="budget.to">
						</div>
					</div>

				</div>

			</div>

		</div>
		<div class="row mt-1">
			<div class="col">
				<button
					type="submit"
					class="btn btn-primary">
					{{'labels.search' | translate}}
				</button>
				<a
					(click)="resetSearch()"
					class="btn btn-default">
					{{'labels.reset' | translate}}
				</a>
			</div>

		</div>
	</form>
</app-card>
